// useEmbedAutoresize — when the widget is loaded inside an iframe (embed=true),
// posts the current document height to the parent so the iframe can grow/shrink
// to fit the content. No-op when not embedded.
import { useEffect } from 'react';

export function useEmbedAutoresize(isEmbedded) {
  useEffect(() => {
    if (!isEmbedded) return;
    if (typeof window === 'undefined' || window.parent === window) return;

    let lastHeight = 0;
    const send = () => {
      const h = Math.max(
        document.documentElement.scrollHeight,
        document.body?.scrollHeight || 0,
      );
      if (h && Math.abs(h - lastHeight) > 8) {
        lastHeight = h;
        window.parent.postMessage({ type: 'resawork:widget-height', height: h }, '*');
      }
    };

    // Initial measure + watchers
    send();
    const ro = new ResizeObserver(send);
    ro.observe(document.documentElement);
    if (document.body) ro.observe(document.body);
    const interval = setInterval(send, 700); // safety net for late mutations
    window.addEventListener('resize', send);

    return () => {
      ro.disconnect();
      clearInterval(interval);
      window.removeEventListener('resize', send);
    };
  }, [isEmbedded]);
}
